import { render, staticRenderFns } from "./SliderPuzzleCaptcha.vue?vue&type=template&id=73055cd6&scoped=true"
import script from "./SliderPuzzleCaptcha.vue?vue&type=script&lang=js"
export * from "./SliderPuzzleCaptcha.vue?vue&type=script&lang=js"
import style0 from "./SliderPuzzleCaptcha.vue?vue&type=style&index=0&id=73055cd6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73055cd6",
  null
  
)

export default component.exports